import r from "./index92.mjs";
import o from "./index93.mjs";
import { createContext as m } from "react";
var u = m(), d = (function() {
  function e() {
    r(this, e), this.usedNamespaces = {};
  }
  return o(e, [{
    key: "addUsedNamespaces",
    value: function(c) {
      var s = this;
      c.forEach(function(a) {
        s.usedNamespaces[a] || (s.usedNamespaces[a] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), e;
})();
export {
  u as I18nContext,
  d as ReportNamespaces
};
